import { gql } from 'graphql-request';
import { requestWithAuth } from '@/utilities/graphQLClient';
import type { Brokerage } from '../useBrokerages';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Response =
  | { errors: Error[] }
  | {
      generatePortfolioLinkUrl: {
        redirectUrl: string;
        portfolioId: string;
        provider: string;
      };
    };

export const queryFn = async ({
  queryKey,
}: QueryFunctionContext<[string, Brokerage['id']]>) => {
  const [, brokerageId] = queryKey;
  const response = await requestWithAuth<Response>(
    gql`
      mutation generatePortfolioLinkUrl(
        $brokerageId: String!
        $platform: String!
      ) {
        generatePortfolioLinkUrl(
          brokerageId: $brokerageId
          platform: $platform
        ) {
          portfolioId
          redirectUrl
          provider
        }
      }
    `,
    {
      brokerageId,
      platform: RUNTIME_ENV === 'native' ? 'native' : 'browser',
    }
  );

  if ('generatePortfolioLinkUrl' in response) {
    return response.generatePortfolioLinkUrl;
  }

  const [firstError] = response.errors;

  throw new Error(firstError?.message ?? 'Failed to generatePortfolioLinkUrl');
};
